/* unplugin-vue-components disabled */import { render } from "./RepairManage.vue?vue&type=template&id=13b3509b&scoped=true"
import script from "./RepairManage.vue?vue&type=script&lang=js"
export * from "./RepairManage.vue?vue&type=script&lang=js"

import "./RepairManage.vue?vue&type=style&index=0&id=13b3509b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b3509b"]])

export default __exports__